import { AlertSeverityEnum } from '@/shared/interfaces/erp/global/errors.interface';
import React from 'react';
import { toast } from 'react-toastify';
import { create } from 'zustand';



type ConfirmDialog = {
  isOpen: boolean;
  title: string;
  subtitle?: string;
  btnTitle?: string;
  onConfirm?: (() => Promise<void>) | (() => void);
  onClose?: () => void;
  onReject?: () => void;

  cancelTextBtn?: string;
  confirmTextBtn?: string;

  shwoCustomInputsForm?: boolean;
  inputsForm?: React.ReactNode;
};

type AuxiliarBtnCreateEditButtons = {
  title: string,
  onClick: () => void;
  disabled: boolean;
};

interface UiState {
  ///* state
  alert: {
    isVisible: boolean;
    message: string;
    severity: AlertSeverityEnum | string;
  };
  isGlobalLoading: boolean;
  confirmDialog: ConfirmDialog;
  generalLoading: boolean;
  openNav: boolean;
  openPopover: boolean;
  auxiliarBtnCreateEditButtons: AuxiliarBtnCreateEditButtons;

  ///* actions
  setAlert: (isVisible: boolean, message: string, severity: AlertSeverityEnum | string, duration?: number) => void;
  setAuxiliarBtnCreateEditButtons: ({
    title,
    onClick,
    disabled,
  }: AuxiliarBtnCreateEditButtons) => void;
  handleCloseAlert: (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => void;
  setIsGlobalLoading: (value: boolean) => void;
  setConfirmDialog: (confirmDialog: ConfirmDialog) => void;
  setConfirmDialogIsOpen: (isOpen: boolean) => void;
  setOpenNav: (value: boolean) => void;
  setOpenPopover: (value: boolean) => void;
  resetAuxBtn: () => void;
  setGeneralLoading: (value: boolean) => void;
}

export const useUiStore = create<UiState>((set, get) => ({
  ///* state
  alert: {
    isVisible: false,
    message: '',
    severity: AlertSeverityEnum.success,
  },
  isGlobalLoading: false,
  generalLoading: false,
  confirmDialog: {
    isOpen: false,
    title: '',
    btnTitle: 'Cancelar',
    onConfirm: async () => { },
    onClose: () => { },
    onReject: () => {

    },

    cancelTextBtn: 'Cancelar',
    confirmTextBtn: 'Confirmar',
    shwoCustomInputsForm: false,
    inputsForm: null,
  },
  openNav: false,
  openPopover: false,

  auxiliarBtnCreateEditButtons: {
    title: '',
    onClick: () => { },
    disabled: true,
  },

  ///* actions
  setAlert: (isVisible, message, severity, duration = 2000) => {

    if (isVisible)
      switch (severity) {
        case AlertSeverityEnum.info:
          toast.info(message, {
            autoClose: duration,
          });
          break;
        case AlertSeverityEnum.error:
          toast.error(message, {
            autoClose: duration,
          });
          break;
        case AlertSeverityEnum.success:
          toast.success(message, {
            autoClose: duration,
          });
          break;
        case AlertSeverityEnum.warning:
          toast.warning(message, {
            autoClose: duration,
          });
          break;
        default:
          break;
      }

    set({
      alert: {
        isVisible,
        message,
        severity
      },
    });

  }
  ,
 
  handleCloseAlert: (
    _event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    set({
      alert: {
        isVisible: false,
        message: '',
        severity: AlertSeverityEnum.success,
      },
    });
  },

  setConfirmDialog: confirmDialog => {
    set({
      confirmDialog,
    });
  },
  setConfirmDialogIsOpen: isOpen => {
    set({
      confirmDialog: {
        ...get().confirmDialog,
        isOpen,
      },
    });
  },

  setIsGlobalLoading: value => {
    set({
      isGlobalLoading: value,
    });
  },
  setOpenNav: value => {
    set({
      openNav: value,
    });
  },
  setOpenPopover: value => {
    set({
      openPopover: value,
    });
  },

  setAuxiliarBtnCreateEditButtons: ({ disabled, onClick, title }) => {
    set({
      auxiliarBtnCreateEditButtons: {
        title,
        onClick,
        disabled,
      },
    });
  },
  resetAuxBtn: () => {
    set({
      auxiliarBtnCreateEditButtons: {
        title: '',
        onClick: () => { },
        disabled: true,
      },
    });
  },
  setGeneralLoading: value => {
    set({
      generalLoading: value,
    });
  },
}));
